import "./listener_add";
import "./listener_delete";
import "./listener_change";
import "./listener_delivery";
import "./listener_save_cartinfo";
import "./listener_products";
import "./listener_userinfo_comment_position";
import VGCatalogCart from "./cart";
import {findID} from "../../../../../modules/vegas/js/util";

let formCart = findID('form-cart');

if (formCart) {
	new VGCatalogCart().update({
		get_delivery_prices: true
	});
}
